/*
 * CAUTION: The values below are relied upon by the P0 CLI. Any changes made here may need to be reflected in and should
 * be tested in the P0 CLI.
 */
import type { ArgsOf, RequestOf } from "@p0security/shared/types/access/index";
import { Access } from "@p0security/shared/types/access/index";

export const CustomAccesses = {
  resource: Access({
    description: "Custom resource access",
    label: "Resource",
    maturity: "ga",
    delegation: {},
    generated: {},
    parameters: {
      application: {
        type: "static",
        label: "Application",
        description: "Select an application to provide access to",
        isPreselect: true,
      },
      item: {
        type: "dynamic",
        label: "Item",
        description: "Select an item to provide access to",
      },
    },
    render: { locator: "application", resource: "item" } as const,
  }),
};

export type CustomAccesses = typeof CustomAccesses;
export type CustomIntegrationAccess = CustomAccesses[keyof CustomAccesses];

export type CustomResourceAccess = CustomAccesses["resource"];

export type CustomResourceRequest = RequestOf<CustomResourceAccess>;

export type CustomResourceArgs = ArgsOf<CustomIntegrationAccess>;
